import type { MenuItemProps } from '@lingoda/ui';
import type { RouterLinkProps } from '@lingoda/router';
import { RouterLink } from '@lingoda/router';
import { MenuItem } from './MenuItem';

export const MenuItemLink = (props: MenuItemProps & Omit<RouterLinkProps, 'onClick'>) => (
    <MenuItem component={RouterLink} {...props} />
);
